import classNames from 'classnames';
import { format } from 'date-fns';
import { useMemo } from 'react';
import { Button, List } from 'yoso';
import { useWinnerNotices } from '~/components/Announcement/Announcement.hooks';
import { T } from '~/components/I18n';
import { Link, LinkProps } from '~/components/Route/Link';
import styles from './AdventureAnnouncement.module.scss';

export type AdventureAnnouncementProps = {
  className?: string;
};

export const AdventureAnnouncement = ({ className }: AdventureAnnouncementProps) => {
  const { data } = useWinnerNotices('adventure');
  const sliced = useMemo(() => data.slice(0, 3), [data]);
  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.header}>
        <h4 className={styles.title}>
          <T name="citizen_adventure_announce_title" />
        </h4>
        <Button<LinkProps>
          as={Link}
          to="/support/notice?category=winners"
          className={styles.button}
          size="small">
          <T name="citizen_button_title_seeall" />
        </Button>
      </div>
      <div className={styles.body}>
        <List className={styles.list}>
          {sliced.map((notice) => (
            <li key={notice.id}>
              <Link to={`/support/notice/${notice.id}`} className={styles.item}>
                <h5 className={styles.itemTitle}>{notice.title}</h5>
                <p className={styles.itemDate}>{format(notice.registered, 'PP')}</p>
              </Link>
            </li>
          ))}
        </List>
      </div>
    </div>
  );
};
